<template>
    <div class="p-30">
        <el-form class="mb-15">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="试卷名称：">
                        <el-input v-model="name" placeholder="请输入试卷名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="试卷分类：">
                        <el-cascader v-model="categoryId" :options="pSortList"
                            :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }"></el-cascader>
                    </el-form-item>
                </el-col>


                <el-col :span="12">
                    <el-form-item label="操作时间：">
                        <el-date-picker v-model="qTime" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-DD HH:mm:ss"
                            value-format="yyyy-MM-DD HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>
        <div class="flex jc-fe">
            <el-button type="primary" @click="search()">
                <i class="el-icon-search" style="margin-right: 5px;"></i>查询
            </el-button>
            <el-button @click="search('refresh')">
                <i class="el-icon-refresh" style="margin-right: 5px;"></i>重置
            </el-button>
        </div>

        <el-dropdown class="ml-5 mb-20" @command="addPaper">
            <el-button type="primary" plain icon="el-icon-plus">
                创建试卷
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">自定义创建</el-dropdown-item>
                <el-dropdown-item command="2">从模版创建</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <tabs class="mb-15" :list="tabList" :active.sync="activeTab" @tabChange="search('refresh')"></tabs>

        <div v-loading="loading">

            <div v-for="(p, i) in paperList  " :key="i" class="class-card pt-15 pb-15 pl-30 pr-30 mb-20 f-12">
                <div class="flex jc-sb mb-15 f-12">
                    <div class="flex jc-fs f-18">
                        {{ p.paperName }}
                    </div>
                    <div class="flex jc-fe">
                        {{ p.totalQuestions }} 大题
                        <div class="pl-10 pr-10">|</div>
                        {{ p.totalSubquestions }} 小题
                        <div class="pl-10 pr-10">|</div>
                        总分 {{ p.totalScore }}分
                    </div>
                </div>
                <div class="flex jc-fs mb-15">
                    <div class="mr-20">试卷分类：{{ p.categoryName }}</div>
                    <!-- <div v-if="activeTab == 0">所属学校/组织：{{ p.schoolName }}</div> -->
                </div>
                <div class="flex jc-sb">
                    <div>
                        【{{ p.creatorName }}】更新于{{ p.createTimeStr }}
                    </div>
                    <div class="flex jc-fe f-18 t-c">
                        <div @click="toPreview(p)" class="ml-30">
                            <i class="el-icon-view c-409eff mr-5"></i>预览
                        </div>
                        <div @click="toDetail(p, 'edit')" class="ml-30">
                            <i class="el-icon-edit c-409eff mr-5"></i>编辑
                        </div>
                        <div v-if="activeTab == 0" @click="paperSetTem(p)" class="ml-30">
                            <i class="el-icon-setting c-409eff mr-5"></i>设置为模版
                        </div>
                        <div v-if="activeTab == 1" @click="toDetail(p)" class="ml-30">
                            <i class="el-icon-copy-document c-409eff mr-5"></i>使用
                        </div>
                        <div @click="paperDelete(p)" class="ml-30">
                            <i class="el-icon-delete c-409eff mr-5"></i>删除
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-empty v-if="paperList && paperList.length == 0" description="暂无数据"></el-empty>
        <el-pagination class="flex jc-fe" @size-change="pageSizeChange" @current-change="pageNoChange"
            :current-page="pageNo" :page-sizes="[10, 20, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
</template>

<script>
import { paperList, paperDelete, zgsourceAllCategory, saveAsTemplate } from '@/api/index2';
import { formatDate } from '@/utils/utils';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { Avatar } from 'element-ui';

import tabs from '@/components/common/tabs/tabs.vue';

export default {
    name: 'paperList',
    components: {
        tabs
    },
    data() {
        return {
            loading: false,

            activeTab: 0,
            tabList: [
                {
                    label: '试卷列表',
                    value: 0
                },
                {
                    label: '我的模版',
                    value: 1
                },
            ],

            name: "",
            publishStatus: null,
            categoryId: null,
            qTime: [],
            searchForm: {},

            pageNo: 1,
            pageSize: 10,
            total: 0,

            paperList: [],
            pSortList: [],

        };
    },
    mounted() {
        this.getList();
        this.getCategory();
    },
    computed: {

    },
    methods: {

        getCategory() {
            let param = {
                type: 3,
            }
            zgsourceAllCategory(param).then((res) => {
                if (res.result == 1) {
                    this.pSortList = this.listFor(res.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },

        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },

        addPaper(val) {
            if (val == 1) {
                let param = {
                    isEdit: false,
                }
                this.$router.push({
                    path: '/paperDetail',
                    query: {
                        param: encrypt(JSON.stringify(param)),
                    }
                });
            } else if (val == 2) {
                this.$router.push({
                    path: '/paperTemList'
                });
            }
        },

        pageNoChange(e) {
            this.pageNo = e;
            this.getList();
        },
        pageSizeChange(e) {
            this.pageSize = e;
            this.getList();
        },
        search(msg) {
            this.pageNo = 1;
            this.total = 0;
            this.paperList = [];
            if (msg == "refresh") {
                this.name = "";
                this.categoryId = null;
                this.publishStatus = null;
                this.qTime = [];
            }
            this.searchForm = {
                name: this.name,
                categoryId: this.categoryId,
                publishStatus: this.publishStatus,
                startTime: this.qTime[0],
                endTime: this.qTime[1],
            }
            this.getList()
        },
        getList() {
            this.loading = true;
            let param = {
                page: this.pageNo,
                pageSize: this.pageSize,

                ...this.searchForm,
            };
            if (this.activeTab == 1) {
                param.isTemplate = 1;
                param.showMyTemplate = 1;
            }

            paperList(param).then((res) => {
                console.log('res :>> ', res.data);
                if (res.result == 1) {
                    this.total = res.data.total;
                    this.pageNo = res.data.pageNum;
                    this.paperList = res.data.list;

                    this.paperList.forEach(p => {
                        p.createTimeStr = formatDate(new Date(p.createTime), 'yyyy-MM-dd hh:mm:ss')
                    });

                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.loading = false;
            });
        },

        toDetail(p, type) {
            if (p.useFlg == 1) {
                this.$message({
                    message: '该试卷已被考试或练习引用，不能编辑！',
                    type: 'warning'
                });
                return;
            }
            let param = {
                paper: p,
                isEdit: type == 'edit' ? true : false,
            }
            this.$router.push({
                path: '/paperDetail',
                query: {
                    param: encrypt(JSON.stringify(param)),
                }
            });
        },
        toPreview(p) {
            let param = {
                paper: p
            }
            this.$router.push({
                path: '/paperPreview',
                query: {
                    param: encrypt(JSON.stringify(param)),
                }
            });
        },

        paperSetTem(p) {
            let param = {
                id: p.id,
            }
            saveAsTemplate(param).then((res) => {
                if (res.result == 1) {
                    this.$message({
                        showClose: true,
                        message: "保存成功",
                        type: 'success'
                    });

                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.loading = false;
            });
        },

        paperDelete(p) {
            if (p.useFlg == 1) {
                this.$message({
                    message: '该试卷已被考试或练习引用，不能删除！',
                    type: 'warning'
                });
                return;
            }
            this.$confirm(`确认要删除此试卷吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let param = {
                    id: p.id,
                }
                paperDelete(param).then((res) => {
                    if (res.result == 1) {
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        });
                    }
                });
            });

        },
    }
};
</script>

<style lang='scss' scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 0px;
}

.class-card {
    border-radius: 20px;
    border: 1px solid #ebeef5;
    transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.class-card:hover {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
    // transform: translateY(-1px);
}
</style>
